import DialogExample from "./examples/Dialog.Example";
import CornerDialogExample from "./examples/CornerDialog.Example";
import CustomDialogExample from "./examples/CustomDialog.Example";

export default [
    {
        title: "Dialog",
        component: DialogExample,
        code: require("!raw-loader!./examples/Dialog.Example.tsx"),
        dependencies: {
            "Dialog.Example.css": require("!raw-loader!./examples/Dialog.Example.css"),
        },
    },
    {
        title: "CornerDialog",
        component: CornerDialogExample,
        code: require("!raw-loader!./examples/CornerDialog.Example.tsx")
    },
    {
        title: "CustomDialog",
        component: CustomDialogExample,
        code: require("!raw-loader!./examples/CustomDialog.Example.tsx")
    }
];
